var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10C14.1211 10 13 11.1211 13 12.5V16.25H15.5V12.5H24.3555L25.5 13.6445V16.25H28V13.6445C28 12.9805 27.7383 12.3438 27.2695 11.875L26.125 10.7305C25.6562 10.2617 25.0195 10 24.3555 10H15.5ZM25.5 23.75V25V27.5H15.5V25V24.375V23.75H25.5ZM28 25H29.25C29.9414 25 30.5 24.4414 30.5 23.75V20C30.5 18.6211 29.3789 17.5 28 17.5H13C11.6211 17.5 10.5 18.6211 10.5 20V23.75C10.5 24.4414 11.0586 25 11.75 25H13V27.5C13 28.8789 14.1211 30 15.5 30H25.5C26.8789 30 28 28.8789 28 27.5V25ZM27.375 21.5625C26.8555 21.5625 26.4375 21.1445 26.4375 20.625C26.4375 20.1055 26.8555 19.6875 27.375 19.6875C27.8945 19.6875 28.3125 20.1055 28.3125 20.625C28.3125 21.1445 27.8945 21.5625 27.375 21.5625Z",
    fill: "#1A2021"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.5b1440fac1a4dd390b876cf99876e016.svg";
export { ForwardRef as ReactComponent };